export default __webpack_public_path__ + "static/media/advanced risk management tools.e70c9bb0.png";